/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ConteneurDto } from '../models/conteneur-dto';
import { ConteneurFixeDto } from '../models/conteneur-fixe-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';


/**
 * Fonctions de gestion des conteneurs fixes
 */
@Injectable({
  providedIn: 'root',
})
export class ConteneursFixesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation conteneurFixeGet
   */
  static readonly ConteneurFixeGetPath = '/api/conteneurs-fixes/{id}';

  /**
   * Renvoie le conteneur fixe spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurFixeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurFixeGet$Response(params: {

    /**
     * Identifiant du conteneur fixe
     */
    id: number;
  }): Observable<StrictHttpResponse<ConteneurFixeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursFixesService.ConteneurFixeGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurFixeDto>;
      })
    );
  }

  /**
   * Renvoie le conteneur fixe spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurFixeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurFixeGet(params: {

    /**
     * Identifiant du conteneur fixe
     */
    id: number;
  }): Observable<ConteneurFixeDto> {

    return this.conteneurFixeGet$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurFixeDto>) => r.body as ConteneurFixeDto)
    );
  }

  /**
   * Path part for operation conteneurFixePut
   */
  static readonly ConteneurFixePutPath = '/api/conteneurs-fixes/{id}';

  /**
   * Met à jour le conteneur fixe spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurFixePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixePut$Response(params: {

    /**
     * Identifiant du conteneur fixe à mettre à jour
     */
    id: number;

    /**
     * Conteneur fixe
     */
    body: ConteneurFixeDto
  }): Observable<StrictHttpResponse<ConteneurFixeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursFixesService.ConteneurFixePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurFixeDto>;
      })
    );
  }

  /**
   * Met à jour le conteneur fixe spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurFixePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixePut(params: {

    /**
     * Identifiant du conteneur fixe à mettre à jour
     */
    id: number;

    /**
     * Conteneur fixe
     */
    body: ConteneurFixeDto
  }): Observable<ConteneurFixeDto> {

    return this.conteneurFixePut$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurFixeDto>) => r.body as ConteneurFixeDto)
    );
  }

  /**
   * Path part for operation conteneurFixeDelete
   */
  static readonly ConteneurFixeDeletePath = '/api/conteneurs-fixes/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurFixeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurFixeDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursFixesService.ConteneurFixeDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurFixeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurFixeDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.conteneurFixeDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation conteneurFixePost
   */
  static readonly ConteneurFixePostPath = '/api/conteneurs-fixes';

  /**
   * Crée le conteneur fixe spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurFixePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixePost$Response(params: {

    /**
     * Conteneur fixe
     */
    body: ConteneurFixeDto
  }): Observable<StrictHttpResponse<ConteneurDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursFixesService.ConteneurFixePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurDto>;
      })
    );
  }

  /**
   * Crée le conteneur fixe spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurFixePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixePost(params: {

    /**
     * Conteneur fixe
     */
    body: ConteneurFixeDto
  }): Observable<ConteneurDto> {

    return this.conteneurFixePost$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurDto>) => r.body as ConteneurDto)
    );
  }

  /**
   * Path part for operation conteneurFixeDesactivate
   */
  static readonly ConteneurFixeDesactivatePath = '/api/conteneurs-fixes/{id}/desactivate';

  /**
   * Désactive le conteneur fixe spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurFixeDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixeDesactivate$Response(params: {

    /**
     * Identifiant du conteneur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ConteneurFixeDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursFixesService.ConteneurFixeDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le conteneur fixe spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurFixeDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixeDesactivate(params: {

    /**
     * Identifiant du conteneur à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ConteneurFixeDto
  }): Observable<number> {

    return this.conteneurFixeDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation conteneurFixeSetNiveauRemplissage
   */
  static readonly ConteneurFixeSetNiveauRemplissagePath = '/api/conteneurs-fixes/{id}/niveau_remplissage';

  /**
   * Modification du niveau de remplissage d'un conteneur.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurFixeSetNiveauRemplissage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixeSetNiveauRemplissage$Response(params: {

    /**
     * Identifiant du conteneur
     */
    id: number;

    /**
     * Niveau de remplissage
     */
    body: number
  }): Observable<StrictHttpResponse<ConteneurFixeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursFixesService.ConteneurFixeSetNiveauRemplissagePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConteneurFixeDto>;
      })
    );
  }

  /**
   * Modification du niveau de remplissage d'un conteneur.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurFixeSetNiveauRemplissage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixeSetNiveauRemplissage(params: {

    /**
     * Identifiant du conteneur
     */
    id: number;

    /**
     * Niveau de remplissage
     */
    body: number
  }): Observable<ConteneurFixeDto> {

    return this.conteneurFixeSetNiveauRemplissage$Response(params).pipe(
      map((r: StrictHttpResponse<ConteneurFixeDto>) => r.body as ConteneurFixeDto)
    );
  }

  /**
   * Path part for operation conteneurFixeGetList
   */
  static readonly ConteneurFixeGetListPath = '/api/conteneurs-fixes/list';

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurFixeGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurFixeGetList$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursFixesService.ConteneurFixeGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurFixeGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  conteneurFixeGetList(params?: {
  }): Observable<void> {

    return this.conteneurFixeGetList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation conteneurFixeLoadList
   */
  static readonly ConteneurFixeLoadListPath = '/api/conteneurs-fixes/load-list';

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `conteneurFixeLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixeLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConteneursFixesService.ConteneurFixeLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `conteneurFixeLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  conteneurFixeLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<void> {

    return this.conteneurFixeLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
